import Glide from '@glidejs/glide';

(function ($) {
	$(document).ready(function () {
		const navStudies = $('.studies__nav .nav__item');
		const faqQuestions = $('.faq__question');
		const sliderPartners = document.querySelector('.glide__partners');
		const sliderCountries = document.querySelector('.glide__countries');
		const sliderColleges = document.querySelector('.glide__colleges');
		const sendRequestButton = $('#send-request');
		const popupButton = $('#popup-close');

		navStudies.click(function () {
			const id = $(this).data('id');
			navStudies.removeClass('active');
			$(this).addClass('active');
			$('.studies__content .content__item').removeClass('active');
			$(`#studies-option-${id}`).addClass('active');
			$('html, body').scrollTop($(`#studies-option-${id}`).offset().top - 150);
		});

		faqQuestions.click(function () {
			const id = $(this).data('id');
			console.log($(this).hasClass('active'));
			if ($(this).hasClass('active')) {
				$(`#faq-anwser-${id}`).removeClass('active');
				$(this).removeClass('active');
			} else {
				$('.faq__question').removeClass('active');
				$('.faq__answer').removeClass('active');
				$(this).addClass('active');
				$(`#faq-anwser-${id}`).addClass('active');
			}
		});

		if (sliderPartners) {
			let glide = new Glide('.glide__partners', {
				type: 'carousel',
				breakpoints: {
					1024: {
						perView: 3
					},
					992: {
						perView: 2
					},
					768: {
						perView: 1
					}
				},
				perView: 4,
				autoplay: 3000,
				gap: '52px'
			});

			glide.mount();
		}

		if (sliderCountries) {
			let glide = new Glide('.glide__countries', {
				type: 'carousel',
				perView: 1,
				focusAt: 'center',
				autoplay: 3000,
				gap: '30px'
			});

			glide.mount();
		}

		if (sliderColleges) {
			let glide = new Glide('.glide__colleges', {
				type: 'carousel',
				perView: 1,
				focusAt: 'center',
				autoplay: 2000,
				gap: '0px'
			});

			glide.mount();
		}

		/* Countdown */

		const getRemainingTime = (deadline) => {
			let now = new Date(),
				remainTime = (new Date(deadline) - now) / 1000,
				remainSeconds = ('0' + Math.floor(remainTime % 60)).slice(-2),
				remainMinutes = ('0' + Math.floor((remainTime / 60) % 60)).slice(-2),
				remainHours = ('0' + Math.floor((remainTime / 3600) % 24)).slice(-2),
				remainDays = Math.floor(remainTime / (3600 * 24));

			return {
				remainSeconds,
				remainMinutes,
				remainHours,
				remainDays,
				remainTime
			};
		};

		const countdown = (deadline, elem, finalMessage) => {
			const el = document.getElementById(elem);

			const timerUpdate = setInterval(() => {
				let t = getRemainingTime(deadline);
				el.innerHTML = `
					<div class="clock__item">
						<div class="clock__number">
							${t.remainDays}                            
						</div>
						<span class="clock__label">
							Días
						</span>
					</div>
					<span class="clock__separator"></span>
					<div class="clock__item">
						<div class="clock__number">
							${t.remainHours}                            
						</div>
						<span class="clock__label">
							Horas
						</span>
					</div>
					<span class="clock__separator"></span>
					<div class="clock__item">
						<div class="clock__number">
							${t.remainMinutes}                            
						</div>
						<span class="clock__label">
							Minutos
						</span>
					</div>
					<span class="clock__separator"></span>
					<div class="clock__item">
						<div class="clock__number">
							${t.remainSeconds}                            
						</div>
						<span class="clock__label">
							Segundos
						</span>
					</div>
				`;

				if (t.remainTime <= 1) {
					clearInterval(timerUpdate);
					el.innerHTML = finalMessage;
					$('.event__message').css('display', 'none');
				}
			}, 1000);
		};

		let eventDate = $('#event-start-date-time').val();

		if (eventDate) {
			let date = eventDate.split(' ')[0];
			let time = eventDate.split(' ')[1];

			let day = date.split('-')[2];
			let month = date.split('-')[1];
			let year = date.split('-')[0];

			countdown(
				`${month}/${day}/${year} ${time}`,
				'event-clock',
				'<span class="clock__message">¡Ya empezó!</span>'
			);
		}

		popupButton.click(function () {
			$('.popup-header').toggleClass('close');
		});

		sendRequestButton.click(function () {
			let data = {
				action: 'getContactsHubAPI'
			};

			$.ajax({
				url: adminAJAX.ajaxurl,
				method: 'POST',
				data: data,
				beforeSend: function () {},
				success: function (res) {
					console.log(res);
				},
				error: function (error) {
					console.error(error);
				}
			});
		});

		// const ENDPOINT = 'https://api.hubapi.com/crm/v3/objects/contacts';

		// const params = {
		// 	method: 'GET',
		// 	headers: {
		// 		'Content-Type': 'application/json',
		// 		Authorization: 'Bearer pat-na1-f6385d52-70d6-41a7-8774-bb67abd207a1'
		// 	}
		// };

		// fetch(ENDPOINT, params)
		// 	.then((response) => {
		// 		console.log(response);
		// 	})
		// 	.then((data) => {
		// 		console.log(data);
		// 	})
		// 	.catch((error) => {
		// 		console.error(error);
		// 	});
	});
})(jQuery);
